const app_items = [
    {
        "id": 1,
        "name": "SAP Monitoring and Performance"
    },
    {
        "id": 2,
        "name": "Storage Space Monitoring and Expansion"
    },
    {
        "id": 3,
        "name": "Support Package Application"
    },
    {
        "id": 4,
        "name": "User and Security Management"
    },
    {
        "id": 5,
        "name": "Transport Management"
    },
    {
        "id": 6,
        "name": "OS and DB Migration Support for ECC"
    },
    {
        "id": 7,
        "name": "SAP Upgrades and Migration to S/4 HANA"
    },
    {
        "id": 8,
        "name": "24/7 Global Coverage"
    },
    {
        "id": 9,
        "name": "Offshore and Nearshore Locations"
    },
    {
        "id": 10,
        "name": "Global Presence to Support Asia, Europe, and Americas"
    },
    {
        "id": 11,
        "name": "Sustain Operations with High Reliability and Quality"
    },
    {
        "id": 12,
        "name": "Flexible Engagement Framework for Changing Business Needs"
    },
    {
        "id": 13,
        "name": "Experienced Consultants with Multiple Skills"
    }
]
export default app_items
